import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_EVENT_SUBSCRIPTION_CHECKOUT_CART } from '@/state/queries/transactions/use-event-subscription-checkout-cart';

export function useCheckoutEventSubscriptionCart(eventId: string | undefined) {
  const { getToken } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (redirectUrlAfterPayment: string): Promise<{ redirectUrl: string }> => {
      if (!eventId) throw new Error('eventId required');
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/transactions/event/${eventId}/subscription-checkout-cart/checkout`;
      return sendJSONRequest({
        url,
        method: METHOD.POST,
        token: token ?? '',
        body: { redirectUrlAfterPayment },
      });
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [GET_EVENT_SUBSCRIPTION_CHECKOUT_CART, eventId] });
    },
  });
}
